import {SlDrawer} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {ReloadManager} from '../reloadManager';

export class OfferBoxer {
    private readonly viewRoot: HTMLElement;
    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;

        this.registerEventListeners();
    }

    private registerEventListeners() {
        this.addListenerChangeAngebotszeile();
        this.addListenerZubehoer();
        this.showMoreOnMobile();
    }

    private addListenerZubehoer() {
        // Layer Zubehoehr beim offerboxer
        const layerZubehoerTriggers = this.viewRoot.querySelectorAll<HTMLAnchorElement>('.layer-zubehoer-trigger');
        layerZubehoerTriggers.forEach((layerZubehoerTrigger: HTMLAnchorElement) => {
            layerZubehoerTrigger.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const cmsmoduleid = layerZubehoerTrigger.dataset.cmsmoduleid;
                var box = layerZubehoerTrigger.dataset.box;
                const drawer = document.querySelector('#layer_' + box + '_' + cmsmoduleid) as SlDrawer;

                if (drawer) {
                    drawer.show();
                    const header = document.querySelector('#header') as HTMLElement;
                    const html = document.querySelector('html') as HTMLElement;

                    header.style.zIndex = '0';
                    html.style.overflow = 'hidden';
                    html.style.height = '100%';
                }
            });
        });
    }

    private addListenerChangeAngebotszeile() {
        // cmsmodul offerboxer > angebotszeile wechseln (artikelfarbe oder groesse)
        const triggers: NodeListOf<HTMLAnchorElement> = this.viewRoot.querySelectorAll('.cms_modul_offerboxer a.trigger_change_angz');

        triggers.forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();

                this.changeAngebotszeile(element);
            });
        });

        // cmsmodul offerboxer > angebotszeile wechseln (tarifkennzeichen)
        const inputTriggers: NodeListOf<HTMLInputElement> = this.viewRoot.querySelectorAll('.cms_modul_offerboxer .trigger_change_angz input');

        inputTriggers.forEach((inputElement) => {
            inputElement.addEventListener('change', (event) => {
                event.preventDefault();

                const triggerElement: HTMLElement | null = inputElement.closest('.trigger_change_angz');
                if (!triggerElement) {
                    return;
                }

                this.changeAngebotszeile(triggerElement);
            });
        });
    }

    /**
     * cmsmodul offerboxer > klick auf mehr details in phone ansicht
     */
    private showMoreOnMobile() {
        const moreDetailsTriggers: NodeListOf<HTMLElement> = this.viewRoot.querySelectorAll('.cms_modul_offerboxer .more_details');

        moreDetailsTriggers.forEach((triggerElement) => {
            triggerElement.addEventListener('click', (event) => {
                event.preventDefault();

                if (triggerElement.classList.contains('open')) {
                    triggerElement.classList.remove('open');
                    triggerElement.innerHTML = 'Weitere Details';
                } else {
                    triggerElement.classList.add('open');
                    triggerElement.innerHTML = 'Weniger Details';
                }
            });
        });
    }

    private changeAngebotszeile(container: HTMLElement) {
        const angzid = container.dataset.angzid ?? '';
        if (angzid === '') {
            return;
        }

        const cmsmoduleid = container.dataset.cmsmodulid ?? '';
        const cmsmodul = document.querySelector('.cms-module-offerboxer[data-module-id="' + cmsmoduleid + '"]');
        if (!cmsmodul) {
            return;
        }

        const form = cmsmodul.querySelector('form.select_angz') as HTMLFormElement;
        if (!form) {
            return;
        }

        const angzidHiddenInput = form.querySelector('[name="angzid"]') as HTMLInputElement;
        angzidHiddenInput.value = angzid;

        const kennzeichen: NodeListOf<HTMLInputElement> = cmsmodul.querySelectorAll('.kennzeichen_choose');
        kennzeichen.forEach((checkbox) => {
            const target = form.querySelector('[name="kennzeichen[' + checkbox.value + ']"]') as HTMLInputElement;

            target.value = checkbox.checked ? checkbox.value : '';
        });
        const reloadManager = new ReloadManager();
        reloadManager.reloadModule(form, undefined, true);

        const header = document.querySelector('#header') as HTMLElement;
        const html = document.querySelector('html') as HTMLElement;

        html.style.removeProperty('overflow');
        html.style.removeProperty('height');
        header.style.removeProperty('z-index');
    }
}
